export default __webpack_public_path__ + "static/media/portfolio.044b9170.jpg";